import {GridDrawer} from './GridDrawer';
import {DataManager} from './DataManager';

export class PublicPage {
    private readonly pageEl: HTMLElement;
    private readonly canvas: HTMLCanvasElement;
    private readonly canvasContainer: HTMLElement;
    private readonly ctx: CanvasRenderingContext2D;
    private readonly tooltip: HTMLElement;
    private readonly dataManager: DataManager;
    private readonly grid: GridDrawer;

    constructor(dataManager: DataManager) {
        this.pageEl = document.getElementById('publicPage') as HTMLElement;
        this.canvas = document.getElementById('publicLifeCanvas') as HTMLCanvasElement;
        this.canvasContainer = document.getElementById('publicCanvasContainer') as HTMLElement;
        this.ctx = this.canvas.getContext('2d')!;
        this.tooltip = document.getElementById('publicTooltip') as HTMLElement;

        this.dataManager = dataManager;
        this.grid = new GridDrawer(this.canvas, this.ctx, this.tooltip, dataManager);
    }

    public async loadPublicCalendar(publicKey: string): Promise<boolean> {
        const calendarData = await this.dataManager.loadPublicCalendar(publicKey);
        return calendarData != null
    }

    private updateCanvasSize(): void {
        this.canvas.width = this.canvasContainer.offsetWidth;
        this.canvas.height = this.canvasContainer.offsetHeight;
        this.drawGrid();
    }

    public drawGrid() {
        this.grid.drawGrid();
    }

    public show() {
        this.pageEl.style.display = 'block';
        this.canvas.width = this.canvasContainer.offsetWidth;
        this.canvas.height = this.canvasContainer.offsetHeight;
        this.drawGrid();
    }

    public hide() {
        this.pageEl.style.display = 'none';
    }

    public onResize() {
        if (this.pageEl.style.display !== 'none') {
            this.updateCanvasSize();
        }
    }

    setupHandlers() {
        this.canvas.addEventListener('mousemove', (e) => {
            if (this.pageEl.style.display === 'none') return;
            const rect = this.canvas.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            const mouseY = e.clientY - rect.top;
            this.grid.highlightCell(mouseX, mouseY);
        });

        this.canvas.addEventListener('mouseout', () => {
            if (this.pageEl.style.display === 'none') return;
            this.grid.highlightCell(-1, -1);
        });
    }
}

